import { CountryIso2Code } from '../../models/country/country-iso-2-code.enum';
import { CountryIsoNumber } from '../../models/country/country-iso-number.enum';

export function countryIso2CodeFactory(
  countryIsoNumber: CountryIsoNumber,
): CountryIso2Code {
  switch (countryIsoNumber) {
    case CountryIsoNumber.Ireland:
      return CountryIso2Code.Ireland;
    case CountryIsoNumber.GreatBritain:
    default:
      return CountryIso2Code.GreatBritain;
  }
}
